import { Flex, Modal, SectionMessage, Space, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { VatExemptionMentionField } from './elements/VatExemptionMentionField'
import * as Styled from './styles'

export const VatExemptionMentionModalBody = (): ReactElement => {
  const { t } = useTranslation()

  return (
    <Modal.Body>
      <Flex flexDirection="column" gap={Spacing.S8}>
        <Text variant="bodyMD">
          {t('settings.organization.external_invoice.general.vat_exemption_mention.modal.body.overview.description')}
        </Text>

        <Styled.VatExemptionMentionSectionWrapper>
          <SectionMessage>
            {t('settings.organization.external_invoice.general.vat_exemption_mention.modal.body.message')}
          </SectionMessage>
        </Styled.VatExemptionMentionSectionWrapper>

        <Space size="s8" />

        <Text variant="bodyLG" weight="semiBold">
          {t('settings.organization.external_invoice.general.vat_exemption_mention.modal.body.scheme_drives.title')}
        </Text>

        <Trans
          i18nKey="settings.organization.external_invoice.general.vat_exemption_mention.modal.body.scheme_drives.list"
          components={{
            ul: <Styled.VatExemptionMentionSchemeDrivesList />,
            li: <li />,
            strong: <Text as="span" weight="bold" />,
          }}
        />

        <Space size="s8" />

        <VatExemptionMentionField />
      </Flex>
    </Modal.Body>
  )
}
